// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SyncLogger = require("./SyncLogger");

var _SyncLogger2 = _interopRequireDefault(_SyncLogger);

var _AsyncLogger = require("./AsyncLogger");

var _AsyncLogger2 = _interopRequireDefault(_AsyncLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var EventEmitter = require("events");

var DefaultOptions = {
    // output log asynchronously
    async: true,
    // use `console` object for logging
    console: console
};

var AlminLogger = function (_EventEmitter) {
    _inherits(AlminLogger, _EventEmitter);

    _createClass(AlminLogger, null, [{
        key: "Events",

        /**
         * Event constants values
         * @returns {{start: string, output: string, flush: string, release: string}}
         */
        get: function get() {
            return {
                output: "output"
            };
        }
    }]);

    function AlminLogger() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, AlminLogger);

        // default logger is `console`
        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        var console = options.console || DefaultOptions.console;
        var isAsyncMode = options.async !== undefined ? options.async : DefaultOptions.async;
        var loggerOptions = {
            console: console
        };
        /**
         * @type {boolean} if current is async mode, return true
         */
        _this.isAsyncMode = isAsyncMode;
        // default: Async logger
        _this.logger = isAsyncMode ? new _AsyncLogger2.default(loggerOptions) : new _SyncLogger2.default(loggerOptions);
        _this.logger.on(AlminLogger.Events.output, function () {
            _this.emit(AlminLogger.Events.output);
        });
        return _this;
    }

    AlminLogger.prototype.flushBuffer = function flushBuffer() {
        this.logger.flushBuffer();
    };

    /**
     * start logging for {@link context}
     * @param {Context} context
     */


    AlminLogger.prototype.startLogging = function startLogging(context) {
        this.logger.startLogging(context);
    };

    AlminLogger.prototype.stopLogging = function stopLogging(context) {
        this.logger.stopLogging(context);
    };

    /**
     * add log to logger
     * @param {*} chunk
     */


    AlminLogger.prototype.addLog = function addLog(chunk) {
        this.logger.addLog(chunk);
    };

    /**
     * release event handlers
     */


    AlminLogger.prototype.release = function release() {
        this.logger.release();
    };

    return AlminLogger;
}(EventEmitter);

exports.default = AlminLogger;
module.exports = exports["default"];
//# sourceMappingURL=AlminLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-logger/lib/AlminLogger.js
// module id = 89
// module chunks = 0